<template>
  <div v-if="showSpinner" id="spinner">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
</template>

<script>
export default {
  name: "spinner",
  computed: {
    showSpinner() {
      return Object.keys(this.$store.state.spinner).length > 0;
    }
  }
};
</script>

<style>
#spinner {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 999;

  display: block;
  width: 200px;
  padding: 20px;
  margin-left: -100px;

  border-radius: 0 0 20px 20px;
  background: rgba(196, 196, 196, 0.8);

  font-size: 50px;
  text-align: center;
}
</style>
